export const dividerStyle = (isAward: boolean) => ({
  margin: "1rem 0",
  marginLeft: isAward ? "5rem" : "0",
  marginRight: "1rem",
});

export const SkeletonStyle = {
  padding: "10px",
  paddingTop: "0",
  borderRadius: "10px",
  marginBottom: "8px",
};

export const spaceBoxStyle = {
  width: "70px",
};
